import { currentUserPath, consultantsPath } from '../../../utilities/api_relative_paths';
import { createQueryString } from '../../../utilities/utilities';

export const getFullUser = () => {
  const params = {
    detail_level: 'full'
  };

  const URL = `${currentUserPath}${createQueryString(params)}`;
  return fetch(URL);
};

export const setActionTaken = async (question, action) => {
  const URL = `${currentUserPath}/user_data_questions`;
  const data = {
    name: question,
    status: action,
  };
  const options = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {'Content-Type': 'application/json'}
  };
  const response = await fetch(URL, options);
  return response;
};

export const updateField = (field, data, userID) => {
  setActionTaken(field, 'updated');
  const URL = `${consultantsPath}/${userID}`;
  const options = {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers: {'Content-Type': 'application/json'},
  };
  return fetch(URL, options);
};

export const updateEmploymentLocation = (employment) => {
  setActionTaken('employment_location', 'updated');
  const URL = `${currentUserPath}/employments/${employment.id}`;
  const options = {
    method: 'PATCH',
    body: JSON.stringify(employment),
    headers: {'Content-Type': 'application/json'},
  };
  return fetch(URL, options);
};
